import { dosDeciComas } from "../../../util/functions"

const formatMoneySign = (amount) => "$"+dosDeciComas(amount)

export default formatMoneySign